import { useTabsContext } from "../../Tabs.context.js";
/**
 * Tabs hook for managing the visible/hidden state of Tabs.Panel
 */
export function useTabPanel({ value }) {
    const { id, selectedValue, makeTabId, makeTabPanelId } = useTabsContext();
    return {
        labelledbyId: makeTabId(id, value),
        hidden: selectedValue !== value,
        id: makeTabPanelId(id, value),
    };
}
//# sourceMappingURL=useTabPanel.js.map